module.exports = __webpack_public_path__ + "img/cw.516587e9.svg";